import { AGENT_HUB_ADMIN_BASE_PATH } from '@lumapps/agent-hub/constants';
import { AskAiConfiguration } from '@lumapps/ask-ai-configurations/types';
import { Route, AppId, createEntityManagementRoutes } from '@lumapps/router';

const { baseRoute, createRoute, editRoute, getEditRoute } = createEntityManagementRoutes({
    slug: `${AGENT_HUB_ADMIN_BASE_PATH}/audience-management`,
    id: 'agent-hub-audience-management',
    appId: AppId.backOffice,
});

export const getAgentAudienceManagementEditionRoute = (configurationId: AskAiConfiguration['id']): Route =>
    getEditRoute(configurationId);

export {
    baseRoute as agentHubAudienceManagementAdminRoute,
    editRoute as agentHubEditAudienceRoute,
    createRoute as agentHubCreateAudienceRoute,
};
